import React from "react"
import Styles from "./popup.less"
import cqPopUpImg from "../../static/pic/cqPopUpImg.png"
import {ErrorLogMsg} from "../../reducer/interface/dataInterface"
interface PopupWinProps {
    type: string
    data: ErrorLogMsg
}
const PopupWindow: React.FunctionComponent<PopupWinProps> = (props) => {
    const renderPopupWin = () => {
        switch (props.type) {
            case "errorLog":
                return <ErrorLog title={""} msg={props.data.msg} />
            case "cqErrorLog":
                return <CqErrorLog data={props.data} />
        }
    }
    return <div className={Styles.popupMask}>{renderPopupWin()}</div>
}

const ErrorLog: React.FunctionComponent<ErrorLogMsg> = ({msg}) => {
    return <div className={Styles.errorLog}>{msg}</div>
}

const CqErrorLog: React.FunctionComponent<{data: ErrorLogMsg}> = ({data}) => {
    return (
        <div className={Styles.cqPopUpBox}>
            <div className={Styles.cqPopUpNav}>
                <div className={Styles.cqPopUpNavText}>{data.title}</div>
            </div>
            <div className={Styles.cqPopUpBody}>
                <div className={Styles.cqPopUpBodyImg}>
                    <img alt={""} src={cqPopUpImg} />
                </div>
                <div className={Styles.cqPopUpBodyMessage}>{data.msg}</div>
            </div>
            <div className={Styles.cqPopUpFooter}>
                <button
                    onClick={() => {
                        data.onCancel && data.onCancel()
                    }}
                    className={Styles.cqPopUpFooterBtn1}
                >
                    取消
                </button>
                <button
                    onClick={() => {
                        data.onOk && data.onOk()
                    }}
                    className={Styles.cqPopUpFooterBtn2}
                >
                    确认
                </button>
            </div>
        </div>
    )
}

export default PopupWindow
